"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function _(msg) {
    return msg;
}
exports._ = _;
function defineMessages(msgs) {
    return msgs;
}
exports.defineMessages = defineMessages;
//# sourceMappingURL=index.js.map


/*****************
 ** WEBPACK FOOTER
 ** ../~/@formatjs/macro/dist/index.js
 ** module id = 1765
 ** module chunks = 0
 **/